<template>
  <div id="app">
    <div v-if="!isNewPassword">
      <div class="grid-wrap" ref="shakedInputArea">
        <form-page class="grid-row__size-16" v-if="!successed">
          <template v-slot:titleLeft>
            <h1>{{ $t('header.resetPassword') }}</h1>
          </template>
          <template v-slot:titleRight>
            <a class="go-back" :href="backUrl">{{ $t('header.goBack') }}</a>
          </template>
          <template v-slot:default>
            <p class="description">{{ $t('form.description') }}</p>
            <email-control
              :label="$t('form.email.label')"
              :placeholder="$t('form.email.placeholder')"
              v-on:input="input"
              v-model="email"
              position="left"
              :customError="errorMessage"
              :includedValidation="includedEmailValidation"
              ref="emailControl"
            />
            <div class="form-page__divider"></div>
            <div class="form-page__buttons-area">
              <base-button
                class="button_size_medium button_type_standart button_family_primary button_color_primary button-send"
                :disabled="isDisabled"
                :loading="isLoading"
                :action="send"
              >
                {{ $t('form.actions.send') }}
              </base-button>
            </div>
            <div class="form-page__bottom-bar">
              <a class="go-back go-back-bottom" :href="actions.loginUrl">{{
                $t('header.goBack')
              }}</a>
            </div>
          </template>
        </form-page>
        <form-page class="grid-row__size-16" v-if="successed">
          <template v-slot:titleLeft>
            <h1>{{ $t('form.successed.header') }}</h1>
          </template>
          <template v-slot:default>
            <p class="to-info">{{ $t('form.successed.info') }}</p>
            <p class="to-email">
              <b>{{ email.value }}</b>
            </p>
            <div class="form-page__plate">
              <p>{{ $t('form.successed.warning.title') }}</p>
              <ul>
                <li>{{ $t('form.successed.warning.case') }}</li>
              </ul>
            </div>
            <p class="maybe-remembered">
              <a :href="actions.loginUrl"
                ><b>{{ $t('form.successed.login') }}</b></a
              >,&nbsp;
              <span>{{ $t('form.successed.hint') }}</span>
            </p>
          </template>
        </form-page>
      </div>
    </div>
    <div v-if="isNewPassword">
      <div class="grid-wrap" ref="shakedInputArea">
        <form-page class="grid-row__size-16">
          <template v-slot:titleLeft>
            <h1>{{ $t('form.newPassword.header') }}</h1>
          </template>
          <template v-slot:default>
            <p class="description">{{ $t('form.newPassword.description') }}</p>
            <base-alert
              v-if="errorMessage != null"
              :text="errorMessage"
              :hasIcon="true"
              state="danger"
              class="choice-group__alert"
            >
            </base-alert>
            <password-control
              :label="$t('form.newPassword.password.label')"
              :includedValidation="includedNewPasswordValidation"
              :placeholder="$t('form.newPassword.password.placeholder')"
              v-on:input="newPasswordInput"
              v-model="newPassword"
              ref="newPasswordControl"
              minLength="6"
              position="left"
            >
            </password-control>
            <div class="form-page__divider"></div>
            <div class="form-page__buttons-area">
              <base-button
                class="button_size_medium button_type_standart button_family_primary button_color_primary button-send"
                :disabled="!canSave"
                :loading="isSaving"
                :action="save"
              >
                {{ $t('form.newPassword.actions.save') }}
              </base-button>
            </div>
          </template>
        </form-page>
      </div>
    </div>
  </div>
</template>

<script>
import FormPage from './../../assets/components/FormPage';
import BaseButton from './../../assets/components/BaseButton';
import EmailControl from './../../assets/components/EmailControl';
import ShakeErrorInputMixin from './../../assets/mixins/ShakeErrorInputMixin';
import BaseAlert from './../../assets/components/BaseAlert';
import PasswordControl from './../../assets/components/PasswordControl';

import axios from 'axios';

export default {
  name: 'ResetPassword',
  components: {
    FormPage,
    BaseButton,
    EmailControl,
    BaseAlert,
    PasswordControl
  },
  mixins: [ShakeErrorInputMixin],
  data() {
    const { actions, isNewPassword, code, userId } = window.vm;
    return {
      self: this,
      email: '',
      newPassword: '',
      isDisabled: false,
      isLoading: false,
      isSaving: false,
      canValidate: false,
      canNewPasswordValidate: false,
      canSave: true,
      successed: false,
      errorMessage: null,
      includedEmailValidation: {
        required: this.$t('validation.email.require'),
        email: this.$t('validation.email.error')
      },
      includedNewPasswordValidation: {
        required: this.$t('validation.newPassword.require'),
        minLength: this.$t('validation.newPassword.minLength')
      },
      isNewPassword,
      actions,
      code,
      userId
    };
  },
  methods: {
    async send() {
      if (!this.checkFields()) {
        return;
      }

      if (this.isLoading) return;
      this.isLoading = true;

      try {
        const resetFormData = new FormData();
        resetFormData.set('email', this.email.value);

        const resetResult = axios
          .post(this.actions.resetPasswordUrl, resetFormData)
          .then(response => {
            const { data } = response;
            if (data.Success === true) {
              this.successed = true;
              this.errorMessage = null;
            } else {
              this.successed = false;
              this.isDisabled = true;
              if (data.EmailNotExists) {
                this.errorMessage = this.$t('validation.email.notExists');
              } else {
                if (data.ErrorMessage) {
                  this.errorMessage = data.ErrorMessage;
                }
              }
            }
          });

        await Promise.all([resetResult]);
      } catch (e) {
        console.log('error on reset password');
      }

      this.isLoading = false;
    },
    async save() {
      if (!this.checkNewPassword()) {
        return;
      }

      if (this.isSaving) return;
      this.isSaving = true;

      try {
        const resetFormData = new FormData();
        resetFormData.set('password', this.newPassword.value);
        resetFormData.set('confirmPassword', this.newPassword.value);
        resetFormData.set('code', this.code);
        resetFormData.set('userId', this.userId);

        const resetResult = axios
          .post(this.actions.newPasswordUrl, resetFormData)
          .then(response => {
            const { data } = response;
            if (data.Success === true) {
              const redirectUrl = data.RedirectUrl
                ? data.RedirectUrl
                : this.actions.accountUrl;
              this.errorMessage = null;
              window.location.href = redirectUrl;
            } else {
              this.isSaving = false;
              if (data.ErrorMessage) {
                this.errorMessage = data.ErrorMessage;
              }
            }
          });

        await Promise.all([resetResult]);
      } catch (e) {
        console.log('error on saving new password');
      }
    },
    checkNewPassword() {
      this.$refs.newPasswordControl.touch();
      this.canSave = this.isNewPasswordValid;
      this.canNewPasswordValidate = true;

      if (!this.isNewPasswordValid) {
        this.shake();
      }

      return this.isNewPasswordValid;
    },
    checkFields() {
      this.$refs.emailControl.touch();
      this.isDisabled = !this.isValid;
      this.canValidate = true;

      if (!this.isValid) {
        this.shake();
      }

      return this.isValid;
    },
    input() {
      this.errorMessage = null;
      this.isDisabled = this.canValidate && !this.isValid;
    },
    newPasswordInput() {
      this.canSave = !this.canNewPasswordValidate || this.isNewPasswordValid;
    },
    shake() {
      setTimeout(() => {
        this.shakeErrorInputs();
      }, 100);
    }
  },
  computed: {
    backUrl() {
      let finalUrl = this.actions.loginUrl;
      const url = new URL(window.location.href);
      const backQuery = url.searchParams.get('backUrl');

      if (backQuery) {
        finalUrl = backQuery;
      }

      return finalUrl;
    },
    isValid() {
      return this.email.isValid;
    },
    isNewPasswordValid() {
      return this.newPassword.isValid;
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/tokens/tokens.scss';
@import '../../assets/normalize.min.css';
@import 'resetPassword.scss';
</style>
